import { render, staticRenderFns } from "./cassation-request.vue?vue&type=template&id=2a16748c&scoped=true&"
import script from "./cassation-request.vue?vue&type=script&lang=js&"
export * from "./cassation-request.vue?vue&type=script&lang=js&"
import style0 from "./cassation-request.vue?vue&type=style&index=0&id=2a16748c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16748c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
